import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'

import axios from 'axios'

import api from './api/commonUrl'
import rem from './utils/rem'
import common from './utils/common'
import store from './store'

import iView from 'iview'
import 'iview/dist/styles/iview.css'

import animated from 'animate.css'

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
require('vue-video-player/src/custom-theme.css')

Vue.prototype.$http = axios;
Vue.prototype.currUrl = api;
Vue.prototype.common = common;

Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(iView);
Vue.use(animated);
Vue.use(VideoPlayer);

new Vue({
  el: '#app',
  mode: 'history',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js